module.exports = __webpack_public_path__ + "assets/img/screen-bg.d9900a64.webp";